import { Card, CardBody, Col, Row } from "reactstrap";


export type Props = {
  className?: string,
};

const Advertisment: React.FunctionComponent<Props> = ({ className }) => {
  return (
    <Card className={`border-0 mb-3 ${className}`}>
      <CardBody className="p-5">
        <p className="text-muted text-right">AI&nbsp;&amp;&nbsp;ML Events Sponsors</p>
        <Row>
          <Col sm={2}>
            <img src="/static/img/modelgw.svg" width={32} height={32} alt="AI &amp; ML Events" className="mr-5"/>
          </Col>
          <Col>
            <a href="https://modelgw.com" target="_blank" className="text-dark d-block">
              <strong>Model Gateway</strong>
              <br/>Is your OpenAI GPT API slow? Get response from OpenAI GPT models API up to <span className="text-primary">15x faster</span>
            </a>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default Advertisment;
